import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import { Editor } from "@tinymce/tinymce-react";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Addjob = () => {
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let token = localStorage.getItem("accessToken");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const onSubmit = async (getData) => {
    setLoading(true);
    try {
      const res = await axios({
        method: "POST",
        url: process.env.REACT_APP_API + "admin/save-jobopeing",
        data: {
          title: getData.tittle,
          employmentType: getData.employment,
          email: getData.email,
          datePosted: getData.startDate,
          validThrough: getData.endDate,
          description: description,
          location: getData?.location,
          experience: getData?.experince,
        },
        headers: {
          "Content-type": "application/json",
          "x-access-token": token,
        },
      });

      if (res.data.status === true) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/career");
      }
    } catch (error) {
      setLoading(false);
      if (error.response !== "" && error.response.data.message !== "") {
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  const disablePastDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Add New Job</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div"></div>
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>Job Title</label>
                <input
                  type="text"
                  name="tittle"
                  {...register("tittle", {
                    required: "Title is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Job Tittle"
                />
                {errors.tittle && (
                  <div className="invalid-feedback">
                    {errors.tittle.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Employment Type</label>
                <input
                  type="text"
                  name="employment"
                  {...register("employment", {
                    required: "Employment type is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Employment Type"
                />
                {errors.employment && (
                  <div className="invalid-feedback">
                    {errors.employment.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Job Location</label>
                <input
                  type="text"
                  name="location"
                  {...register("location", {
                    required: "Location is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Job Location"
                />
                {errors.location && (
                  <div className="invalid-feedback">
                    {errors.location.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Experience</label>
                <input
                  type="text"
                  name="experince"
                  {...register("experince", {
                    required: "Experience is required",
                    pattern: {
                      value: /^[A-Za-z0-9 _]+$/,
                      message: "Please enter a valid experince",
                    },
                  })}
                  placeholder="Enter Experince"
                />
                {errors.experince && (
                  <div className="invalid-feedback">
                    {errors.experince.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  min={disablePastDate()}
                  {...register("startDate", {
                    required: "Start Date is required",
                  })}
                  placeholder="Enter Start Date"
                />
                {errors.startDate && (
                  <div className="invalid-feedback">
                    {errors.startDate.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>End Date</label>
                <input
                  type="date"
                  name="endDate"
                  min={disablePastDate()}
                  {...register("endDate")}
                  placeholder="Enter End Date"
                />
                {errors.endDate && (
                  <div className="invalid-feedback">
                    {errors.endDate.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value:
                        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                  placeholder="Enter Email"
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </div>
              <div className="formInput"></div>
              <div className="formInputDescription">
                <label>Job Description</label>
                <Editor
                  initialValue="<p>This is the initial content of the editor.</p>"
                  apiKey="4xerbueqmh9h3gt7gkvu7xnlqgntlyv3qlqtcx6kr7du2cl2"
                  init={{
                    selector: "textarea",
                    height: 300,
                    menubar: true,
                    toolbar: "bottom",
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                      "lists",
                    ],
                    toolbar:
                      "undo redo | formatselect | " +
                      "bold italic backcolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                  onEditorChange={(newText) => setDescription(newText)}
                />
              </div>

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addjob;
